module.exports = __webpack_public_path__ + "static/desktop/img/photobook-3.d2ac3ce4.png";